const ServicesCard = ({ application }) => {

    const handleLinkRedirection = () => {
        const maxItems = 3;

        // Get existing array or initialize
        let quickLinksArray = JSON.parse(localStorage.getItem("quickLinksArray")) || [];

        const existingIndex = quickLinksArray.findIndex(item => item.id === application.id);
        const newAccessedAt = new Date().toISOString();

        if (existingIndex === -1) {
            const newItem = { 
                id: application.id, 
                title: application.title, 
                accessApplicationURL: application.accessApplicationURL, 
                accessedAt: newAccessedAt 
            };
            quickLinksArray.unshift(newItem);
        } else {
            quickLinksArray[existingIndex].accessedAt = newAccessedAt;

            if (existingIndex !== 0) {
                const [item] = quickLinksArray.splice(existingIndex, 1);
                quickLinksArray.unshift(item);
            }
        }

        // Keep only the latest 3 items
        quickLinksArray = quickLinksArray.slice(0, maxItems);

        localStorage.setItem("quickLinksArray", JSON.stringify(quickLinksArray));

        if (application.accessApplicationURL) {
            console.log("application.openInANewWindow   ",application.openInANewWindow);
            if(application.openInANewWindow){
                window.open(application.accessApplicationURL, "_blank");
            }else{
                window.location.href = application.accessApplicationURL; 
            }
        }
    };


    return (
        <div className="col-12 col-lg-6 col-xl-3 ">
            <div className="services-card">
                <div className="card-content">
                    <div className="tag">
                        {application.serviceType.name}
                    </div>
                    <div className="title">{application.title}</div>
                    <p className="description">{application.description}</p>
                </div>
                <div className="card-actions">
                    <a href="#" onClick={(e) => { e.preventDefault(); handleLinkRedirection(); }} className="card-button">
                        <span className="card-button-text">{`${Liferay.Language.get("dwtc.access.application")}`}</span>
                        <div className="icon-external"></div>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default ServicesCard;